<div class="receipt-header">
  <h3 class="text-primary mb-2">
    {{ userName ? ('receipt.headerWithUserName' | translate: { userName: userName }) : 'receipt.header' | translate }}
  </h3>
  <div class="sent-receipt" *ngIf="email">
    <span [translate]="'receipt.weHaveSentReceipt'"></span>&nbsp;{{email}}
  </div>
</div>
